import { useState } from "react";
import { Slider, Tag } from "antd";
import { get, map, isEmpty, head, last } from "lodash";

const CURRENCY_SYMBOL = "€";

const computePriceRanges = (minPrice, maxPrice) => {
  if (minPrice === maxPrice) {
    return [];
  }
  const price = maxPrice - minPrice;

  if (price < 1300) {
    return [];
  }

  const priceRanges = [];
  const firstPrice =
    (maxPrice < 400
      ? Math.round(price * 0.2)
      : Math.round((price * 0.2) / 100) * 100) + minPrice;
  priceRanges.push([minPrice, firstPrice]);
  const secondPrice =
    (maxPrice < 400
      ? Math.round(price * 0.4)
      : Math.round((price * 0.4) / 100) * 100) + minPrice;
  priceRanges.push([firstPrice, secondPrice]);
  const thirdPrice =
    (maxPrice < 400
      ? Math.round(price * 0.6)
      : Math.round((price * 0.6) / 100) * 100) + minPrice;
  priceRanges.push([secondPrice, thirdPrice]);
  const fourthPrice =
    (maxPrice < 400
      ? Math.round(price * 0.8)
      : Math.round((price * 0.8) / 100) * 100) + minPrice;
  priceRanges.push([thirdPrice, fourthPrice]);
  priceRanges.push([fourthPrice, maxPrice]);
  return priceRanges;
};

const CategoryElementPrice = ({
  parameter,
  handleChange,
  selected,
  options = {},
}) => {
  const { styles = {}, headline = "" } = options;

  let slider = {};
  slider.selected = [];

  slider.min = get(options, "min", 0);
  slider.max = get(options, "max");

  const [sliderValues, setSliderValues] = useState({
    min: get(selected, "min", slider.min),
    max: get(selected, "max", slider.max),
  });

  const priceRanges = computePriceRanges(slider.min, slider.max);

  return (
    <div className={styles?.parameter}>
      {headline ? headline : <h4 className={styles?.headline}>Cena</h4>}
      {!isEmpty(priceRanges) ? (
        <div>
          {map(priceRanges, (range, index) => {
            if (sliderValues.min == range[0] && sliderValues.max == range[1]) {
              return (
                <Tag.CheckableTag
                  key={`price-range-${index}`}
                  style={{
                    fontSize: "0.65em",
                    marginRight: "2px",
                    marginBottom: "2px",
                  }}
                  checked={true}
                  onChange={(checked) => {
                    if (checked) {
                      const selectedMin = head(range);
                      const selectedMax = last(range);
                      setSliderValues({ min: selectedMin, max: selectedMax });
                      handleChange("cena", [selectedMin, selectedMax]);
                    } else {
                      setSliderValues({ min: slider.min, max: slider.max });
                      handleChange("cena", [slider.min, slider.max]);
                    }
                  }}
                >
                  {range[0]} {CURRENCY_SYMBOL} - {range[1]} {CURRENCY_SYMBOL}
                </Tag.CheckableTag>
              );
            } else {
              return (
                <Tag
                  key={`price-range-${index}`}
                  style={{
                    fontSize: "0.65em",
                    marginRight: "2px",
                    marginBottom: "2px",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    const selectedMin = head(range);
                    const selectedMax = last(range);
                    setSliderValues({ min: selectedMin, max: selectedMax });
                    handleChange("cena", [selectedMin, selectedMax]);
                  }}
                >
                  {range[0]} {CURRENCY_SYMBOL} - {range[1]} {CURRENCY_SYMBOL}
                </Tag>
              );
            }
          })}
        </div>
      ) : (
        ""
      )}

      <Slider
        style={{ marginBottom: 0 }}
        range
        min={slider.min}
        max={slider.max}
        defaultValue={[
          get(sliderValues, "min", get(selected, "min", slider.min)),
          get(sliderValues, "max", get(selected, "max", slider.max)),
        ]}
        // value={[
        //     get(selected, "min", slider.min),
        //     get(selected, "max", slider.max),
        //   ]}
        allowCross={false}
        dotStyle={{ display: "none" }}
        onChange={(values) => {
          setSliderValues({ min: head(values), max: last(values) });
        }}
        tipFormatter={(value) => `${value} ${CURRENCY_SYMBOL}`}
        onAfterChange={(values) => {
          const selectedMin = head(values);
          const selectedMax = last(values);

          setSliderValues({ min: selectedMin, max: selectedMax });
          handleChange("cena", [selectedMin, selectedMax]);
        }}
      />
      <div className={styles.spaceWrapper} style={{ marginTop: "10px" }}>
        <span>
          {sliderValues.min} {CURRENCY_SYMBOL}
          {/* <InputNumber
            disabled
            value={sliderValues.min}
            onChange={(value) => {
              if (toNumber(value) < sliderValues.max) {
                setSliderValues({
                  ...{ min: toNumber(value), max: sliderValues.max },
                });
              }
            }}
          /> */}
        </span>
        <span>
          {sliderValues.max} {CURRENCY_SYMBOL}
          {/* <InputNumber
            disabled
            defaultValue={sliderValues.max}
            onChange={(value) => {
              if (toNumber(value) > sliderValues.min) {
                setSliderValues({
                  min: sliderValues.min,
                  max: toNumber(value),
                });
              }
            }}
          /> */}
        </span>
      </div>
    </div>
  );
};

export default CategoryElementPrice;
